import { EnumKeyboardAction } from './enums/keyboard-action.interface';

export const MIN_TEXT_LENGTH = 3;
export const DEBOUNCE_TIME = 500;
export const INITIAL_HIGHLIGHTED_INDEX = -1;
export const FIRST_ITEM_INDEX = 0;
export const NAVIGATION_INCREMENT = 1;
export const SCROLL_TOP_POSITION = 0;

export const CSS_AUTOCOMPLETE_ITEM_SELECTOR = '.autocomplete__item';
export const CSS_HIGHLIGHTED_CLASS = 'autocomplete__item--highlighted';
export const CSS_SCROLL_BEHAVIOR = 'smooth';

export const CSS_DROPDOWN_CLASS = 'autocomplete__dropdown';
export const OVERLAY_PANEL_CLASS = 'sgt-autocomplete-overlay-panel';

export const KEY_ARROW_DOWN = 'ArrowDown';
export const KEY_ARROW_UP = 'ArrowUp';
export const KEY_ENTER = 'Enter';
export const KEY_ESCAPE = 'Escape';

export const KEY_ACTION_MAP = new Map<string, EnumKeyboardAction>([
  [KEY_ARROW_DOWN, EnumKeyboardAction.NAVIGATE_DOWN],
  [KEY_ARROW_UP, EnumKeyboardAction.NAVIGATE_UP],
  [KEY_ENTER, EnumKeyboardAction.SELECT_ITEM],
  [KEY_ESCAPE, EnumKeyboardAction.CLEAR_HIGHLIGHT],
]);

export const SUPPORTED_KEYS = [
  KEY_ARROW_DOWN,
  KEY_ARROW_UP,
  KEY_ENTER,
  KEY_ESCAPE,
];
